/**
 * 检查一个值是否是有限的数字
 * @returns {boolean}
 */
export function isFiniteNumber(value: unknown): value is number {
    return typeof value === 'number' && Number.isFinite(value)
}

/**
 * 检查一个值是否是字符串
 * @returns {boolean}
 */
export function isString(value: unknown): value is string {
    return typeof value === 'string'
}
